export function animateScrollTop(target, y, duration = 1) {
    const start = new Date().getTime();
    const top = target.scrollTop;
    const delta = Math.round(y - top);

    const animate = () => {
        const now = new Date().getTime();
        const progress = now - start;
        const percent = Math.min(progress / (duration * 60), 1);
        target.scrollTop = top + Math.ceil(delta * percent);
        if (percent < 1) {
            requestAnimationFrame(animate);
        }
    };
    requestAnimationFrame(animate);
}
